module.exports = __webpack_public_path__ + "static/media/tabula_colapsed.572e34c7.svg";